
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/aad761441c4615b4ec8ab9e4024e3637/3a53a6d0d699cfca922322d0c183847b.png" 
                alt="Eyad Investment" 
                className="h-16 w-16 object-contain"
              />
              <div>
                <div className="text-2xl font-bold text-white">亞德貝增財務顧問有限公司</div>
                <div className="text-sm text-gray-400">Eyad Investment</div>
              </div>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              讓投資回歸理性與秩序，建立穩健的財務基礎。<br />
              找到屬於自己的投資節奏，像找到對的人一樣。
            </p>
            <div className="space-y-2 text-gray-400">
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span className="text-sm">新北市板橋區中山路一段10號11樓</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href="mailto:cs@eyad.investments" className="text-sm hover:text-yellow-500 cursor-pointer">
                  cs@eyad.investments
                </a>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-file-list-line"></i>
                <span className="text-sm">統一編號：60451968</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">快速連結</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-yellow-500 transition-colors cursor-pointer">
                  首頁
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-yellow-500 transition-colors cursor-pointer">
                  關於我們
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-yellow-500 transition-colors cursor-pointer">
                  服務項目
                </Link>
              </li>
              <li>
                <a href="https://eyad.kaik.io" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-500 transition-colors cursor-pointer">
                  觀點文章與課程
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">追蹤我們</h3>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/eyad.trades" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-yellow-500 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a 
                href="https://www.tiktok.com/@eyad.trades" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-yellow-500 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-tiktok-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} 亞德貝增財務顧問有限公司 Eyad Investment. All rights reserved. | <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-500 cursor-pointer">Website Builder</a></p>
        </div>
      </div>
    </footer>
  );
}
